export const Urls = {
    GetMdmPipelines: "MdmPipeline/GetMdmPipelines",
    RunPipeline: "MdmPipeline/RunPipeline",
    RunPipelineCommand: "MdmPipeline/RunPipelineCommand",
    ClearEtlProcessExecutionWarning: "MdmPipeline/ClearEtlProcessExecutionWarning",
    FailEtlProcessExecution: "MdmPipeline/FailEtlProcessExecution",
};
